import React, {Component} from "react";

import Loader from "../../Utils/Loader"
import Chart from "react-google-charts";
import EmptyChart from "../EmptyChart";

class TransactionsLineChart extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.data = props.data;
        this.vAxisLabel = props.vAxisLabel;
        this.lineColor = props.lineColor;
    }

    componentDidMount() {
        this.setState({charData: this.data})
    }

    static getDerivedStateFromProps(nextProps, state) {

        if (nextProps.data !== state.charData) {
            return {
                charData: nextProps.data,
            }
        }

        if (nextProps.count !== state.count) {
            return {
                count: nextProps.count
            }
        }

        return null
    }

    render() {
        return (
            this.state.count ? (
                <Chart
                    width={'100%'}
                    height={300}
                    chartType="LineChart"
                    loader={<Loader/>}
                    data={this.state.charData}
                    options={{
                        curveType: 'none',
                        interpolateNulls: true,
                        chartArea: {
                            width: '80%',
                            height: '70%'
                        },
                        vAxis: {
                            title: this.vAxisLabel,
                            titleTextStyle: {italic: false},
                            textPosition: 'out',
                            textStyle: {
                                fontSize: 12
                            }
                        },
                        hAxis: {
                            textPosition: 'out',
                            slantedText: true,
                            titleTextStyle: {italic: false},
                            textStyle: {
                                fontSize: 12
                            }
                        },
                        legend: 'none',
                        height: 300,
                        width: '100%',
                        series: {
                            0: {color: this.lineColor},
                        }
                    }}
                />
            ) : (
                <EmptyChart/>
            )

        )
    }

}

export default TransactionsLineChart;



// WEBPACK FOOTER //
// ./src/Components/Charts/TransactionsLineChart/index.js